//DEFINE THE ACTIONS TO TRIGGER
export const GET_ABMMENU_LOADING = 'GET_ABMMENU_LOADING';
export const GET_ABMMENU_FAIL = 'GET_ABMMENU_FAIL';
export const GET_ABMMENU_SUCCESS = 'GET_ABMMENU_SUCCESS';


export type ABMMenuType =  {
    menuinfo_id: number,
    menuinfo_order: number,
    menuinfo_name: string,
    menuinfo_title: string,
    menuinfo_url: string,
    menuinfo_category: string,
};


export interface GetABMMenuLoading {
    type: typeof GET_ABMMENU_LOADING
}

export interface GetABMMenuFail {
    type: typeof GET_ABMMENU_FAIL
}

export interface GetABMMenuSuccess {
    type: typeof GET_ABMMENU_SUCCESS,
    payload: ABMMenuType[] | undefined
}

export type GetABMMENUDispatchTypes = GetABMMenuLoading | GetABMMenuFail | GetABMMenuSuccess;
